import {useNavigate} from 'react-router-dom'
import {useTranslation} from '../utils/useTranslation'
import {theme} from '../theme'

export default function Error403() {
  const {t} = useTranslation()
  const navigate = useNavigate()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '2rem',
        textAlign: 'center',
      }}>
      <h1
        style={{
          fontSize: '4rem',
          margin: '0',
          color: theme.palette.error.main,
        }}>
        403
      </h1>
      <h2 style={{fontSize: '1.5rem', marginTop: '1rem'}}>
        {t('permissions:forbiddenTitle')}
      </h2>
      <p
        style={{
          fontSize: '1rem',
          color: theme.palette.text.secondary,
          marginTop: '1rem',
        }}>
        {t('permissions:forbiddenMessage')}
      </p>
      <button
        onClick={() => navigate(-1)}
        style={{
          marginTop: '2rem',
          padding: '0.75rem 1.5rem',
          fontSize: '1rem',
          backgroundColor: theme.palette.info.main,
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
        }}>
        {t('permissions:goBack')}
      </button>
    </div>
  )
}
